import ZipcodeModule from '@/components/referral/Zipcode';
import Button from '@/components/common/Button';
import { useCroppedImage } from '@weee-fe/module';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

type InviteeCouponProps = {
  data: any;
  onNextStep: (step: number) => void;
  clickTrack: (type: string) => void;
  isLogin?: boolean;
};

const InviteeCoupon = ({ data, onNextStep, clickTrack, isLogin }: InviteeCouponProps) => {
  const { getCroppedUrl } = useCroppedImage();
  const { t, lang } = useTranslation('common');

  return (
    <div data-testid="wid-invitee-coupon" className="relative w-full mt-3 overflow-hidden">
      <div
        data-testid="wid-invitee-coupon-title"
        className="px-[42px] py-2.5 text-primary-1 enki-heading-2xl text-center"
        dangerouslySetInnerHTML={{ __html: t('referral_receiver_title') }}></div>
      <div className="relative w-[350px] h-[139px] mx-auto mt-3">
        <div className="absolute -left-[33px] -bottom-[19px] w-[116px] h-[116px] rounded-full bg-[#FCE1F8]"></div>
        <div className="absolute -right-[59px] -top-[23px] w-[153px] h-[152px] rounded-full bg-primary-2"></div>
        <div className="relative w-[350px] h-[139px] bg-reserved-true-white shadow-[0px_8px_14px_0px_rgba(0,0,0,0.05)] drop-shadow-[0px_8px_14px_0px_rgba(0,0,0,0.05)] rounded-400 overflow-hidden">
          <div className="absolute top-[50%] left-0 transform -translate-y-1/2 w-[17px] h-[34px] rounded-r-full bg-[#FCE1F8]"></div>
          <div className="absolute top-[50%] right-0 transform -translate-y-1/2 w-[17px] h-[34px] rounded-l-full bg-primary-2"></div>
          <div className="w-full h-full flex justify-between items-center">
            <div
              data-testid="wid-invitee-coupon-remark"
              className="box-border w-[211px] h-[139px] pl-[35px] pr-4 text-promo-100-fg-default bg-[#F43C7E] flex flex-col justify-center flex-none">
              <span
                className="enki-heading-3xl-strong"
                dangerouslySetInnerHTML={{
                  __html: t('share_referral_coupon_remark', { amount: Number(data?.coupon_amount) })
                }}></span>
              {data?.coupon_num > 1 && (
                <span data-testid="wid-invitee-coupon-remark-desc" className="enki-body-xs-medium">
                  {t('share_referral_coupon_remark_desc')}
                </span>
              )}
            </div>
            <div
              data-testid="wid-invitee-coupon-user"
              className="box-border w-[139px] h-[139px] pl-[15px] pr-[23px] bg-reserved-true-white flex flex-col items-center justify-center flex-none">
              <div
                data-testid="wid-invitee-coupon-avatar"
                className="box-border flex-none w-[64px] h-[64px] mb-[9px] rounded-full border-[4px] border-solid border-surface-100-bg enki-elevation-4 overflow-hidden">
                <img
                  src={data?.headImgUrl}
                  alt="invite user image"
                  className="w-full h-full rounded-full object-cover"
                />
              </div>
              <div
                data-testid="wid-invitee-coupon-user-name"
                className="w-full flex flex-col items-center text-center enki-body-2xs-medium text-surface-100-fg-minor overflow-ellipsis line-clamp-3 overflow-hidden">
                <Trans
                  i18nKey={'common:share_referral_coupon_subtitle'}
                  components={{
                    div: <div className="text-black mt-1">{data?.alias}</div>
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 max-w-[390px] mx-auto">
        {!isLogin ? (
          <>
            <ZipcodeModule
              amount={Number(data?.coupon_amount)}
              onSuccess={() => {
                onNextStep(1);
              }}
            />
            <div
              data-testid="wid-invitee-coupon-login-tip"
              className="px-5 mt-[17px] text-center enki-body-xs-medium text-surface-100-fg-default">
              {t('haveAccount')}
              <span
                data-testid="btn-login"
                onClick={() => {
                  clickTrack('login_in');
                  onNextStep(1);
                }}
                className="text-link-base-1 ml-1">
                {t('login_uppercase')}
              </span>
            </div>
          </>
        ) : (
          <Button
            dataTestId="btn-continue-shopping"
            type="primary"
            size="large"
            className="mt-6 w-full max-w-[350px] mx-auto"
            onClick={() => {
              window.location.href = '/';
            }}>
            {t('continue')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default InviteeCoupon;
